function makeConfigRef(initialValue) {
  const listeners = /* @__PURE__ */ new Set();
  const valueRef = {
    current: initialValue
  };
  const getValue = () => {
    const value = valueRef.current;
    return value instanceof Function ? value() : value;
  };
  return Object.freeze({
    get() {
      return getValue();
    },
    /**
     * asserts that the currently resolved value is sync and returns it without
     * the "MaybePromise" abstraction
     *
     * this operation is considered dangerous, as it can potentially throw
     * runtime exceptions - but it can greatly help in scenarios, where we can
     * safely infer that the value will always be available and where we do not
     * wish to implement an async flow
     *
     * (e.g. the case for the @core/logger implementation, where we will only
     * ever need to read environment variables which are always available as
     * synchroneous values)
     */
    dangerouslyAssertSyncValue() {
      const value = getValue();
      if (value instanceof Promise) {
        throw new Error(
          "makeConfigRef().getAssertedValue(): current value hasn't been resolved, "
        );
      }
      return value;
    },
    observe(listener) {
      const uniqueListener = () => listener();
      listeners.add(uniqueListener);
      return () => {
        listeners.delete(uniqueListener);
      };
    },
    __update(nextValue) {
      valueRef.current = nextValue;
      if (nextValue instanceof Promise) {
        nextValue.then((resolvedValue) => {
          const value = getValue();
          if (value === nextValue) {
            valueRef.current = resolvedValue;
          }
        }).catch((err) => {
          console.error(err, "Failed to update value");
        });
      }
      listeners.forEach((listener) => {
        const res = listener();
        if (res && "catch" in res) {
          res.catch((err) => {
            console.error(err, "Listener failed to complete");
          });
        }
      });
    }
  });
}

export { makeConfigRef };
//# sourceMappingURL=util.make-config-ref.js.map
